<template id="principal">
  <div>
    <v-container class="grey lighten-5">
      <v-row dense>
        <v-col cols="12" md="4" sd="4">
          <v-text-field label="Texto a generar QR" dense v-model="codigoqr">
          </v-text-field>
        </v-col>
        <v-col cols="12" md="4" sd="4">
          <v-text-field label="Cantidad de celdas" dense v-model="cantidad">
          </v-text-field>
        </v-col>
        <v-col cols="12" md="2" sd="2">
          <v-text-field label="Tamaño" dense v-model="dimension">
          </v-text-field>
        </v-col>
        <v-col cols="12" md="2" sd="2">
          <v-btn color="red lighten-2" dark @click="generarQR">
            Generar QR
          </v-btn>
        </v-col>
      </v-row>

      <div id="printtopaper">
        <v-row dense align="center">
          <v-col
            align-self="center"
            cols="12"
            md="4"
            sd="4"
            v-for="cod in codigos"
            :key="cod"
          >
            <v-row align="center" justify="center">
              {{ cod }}
            </v-row>
            <v-row align="center" justify="center">
              <vue-qr :text="cod" :size="dimension"></vue-qr>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </v-container>
  </div>
</template>
<script>
import VueQr from "vue-qr";
export default {
  data: (vm) => ({
    codigoqr: "",
    dimension: 200,
    valid: false,
    cantidad: 0,
    codigos: [],
  }),
  components: { VueQr },
  methods: {
    generarQR() {
      this.codigos = [];
      const cantidad = this.cantidad;

      if (cantidad == "0") {
        this.codigos.push(this.codigoqr);
      } else {
        for (let i = 1; i <= this.cantidad; i++) {
          const fill = (number, len) =>
            "0".repeat(len - number.toString().length) + number.toString();

          let nuevocodigo = this.codigoqr + " / " + fill(Number(i), 2);
          this.codigos.push(nuevocodigo);
        }
      }
    },
  },
};
</script>

<style>
.conteiner {
  margin: 0 auto;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
</style>
